<template lang="pug">
  .auth_modal(v-if="isAuthModalVisibility")
    v-icon(v-if="!isRegisterPage" @click="toggleAuthModal") mdi-close
    .auth_modal_img
      .auth_modal_img_border
        img(v-if="isRegisterPage" src="@/assets/register.png")
        img(v-else src="@/assets/authModal.png")
    .auth_modal_content
      h3 {{ $t(frameTitle) }}
      template(v-if="frameContents.length > 0")
        div(v-for="(frameContent, index) in frameContents" :key="index").auth_modal_content_item
          span {{ `${index + 1}.` }}
          span {{ $t(`${frameContent}`) }}
    v-btn(v-if="isRegisterPage" depressed color="primary" @click="getDeepLink()") {{ $t('label.mpay.download') }}
    v-btn(v-else depressed color="primary" @click="getDeepLink()" class="mb-5") {{ $t('misc.auth.sign.app') }}
</template>
<script>

export default {
  name: 'AppFrame',
  props: {
    isAuthModalVisibility: {
      type: Boolean,
      required: false,
    },
    isRegisterPage: {
      type: Boolean,
      required: false,
    },
    frameTitle: {
      type: String,
      default: '',
    },
    frameContents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: 'https://sbplus.mpay.az/mpay-link',
      size: 202,
      userAgent: window.navigator.userAgent,
    };
  },
  methods: {
    toggleAuthModal() {
      this.$emit('closeAuthModal');
    },
    getDeepLink() {
      if (this.userAgent.match(/iPhone/) || this.userAgent.match(/Android/)) {
        window.location.href = 'mpay://auth/register';
      }
      setTimeout(() => {
        if (this.userAgent.match(/iPhone/)) {
          window.location.href = 'https://apps.apple.com/us/app/mpay-e-wallet/id6450408051';
        } else if (this.userAgent.match(/Android/)) {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.mpayapp';
        } else if (this.userAgent.match(/huawei/)) {
          window.location.href = 'https://appgallery.huawei.com/#/app/C109994723';
        }
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/auth.scss';
@import '@/styles/components/appFrame.scss';
</style>
